var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"exportDonors":_vm.exportDonors,"finished":_vm.finished,"regenerating":_vm.regenerating,"progress":_vm.progress})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }